






















































































































































import {Component, Vue} from "vue-property-decorator";
import TaxObligationDTO from "@/dto/tax/TaxObligationDTO";
import TaxObligationFilter, {TaxObligationSortField} from "@/dto/tax/TaxObligationFilter";
import TaxObligationService from "@/services/TaxObligationService";
import SimpleProfileSearch from "@/components/common/SimpleProfileSearch.vue";
import PortalInput from "@/components/common/PortalInput.vue";
import PortalSelect from "@/components/common/PortalSelect.vue";
import SelectOption from "@/components/common/SelectOption";
import PaginationComponent from "@/components/util/PaginationComponent.vue";
import ProfileDTO from "@/dto/profile/ProfileDTO";
import moment from "moment";
import {processError} from "@/utils/ComponentUtils";
import { YEARS, Period } from "@/constants/DateTimeConstants";
import { STATE_LIST } from "@/constants/ProfileConstants";
import { TaxReportForm, getTaxReportFormLabel } from "@/constants/TaxReportForm";
import CreateTaxObligationModal from "@/components/admin/tax/CreateTaxObligationModal.vue";

@Component({
  components: {
    SimpleProfileSearch,
    PortalInput,
    PortalSelect,
    PaginationComponent,
    CreateTaxObligationModal
  }
})
export default class TaxCalendar extends Vue {

  private filter = new TaxObligationFilter();
  private taxObligations: TaxObligationDTO[] = [];
  private totalPages = 1;

  get obligationTypeOptions() {
    const list = Object.values(TaxReportForm).map(type => SelectOption.builder().title(getTaxReportFormLabel(type)).value(type).build());
    return [SelectOption.builder().title("All").value(null).build(), ...list];
  }

  get stateOptions() {
    const list = STATE_LIST.map(state => SelectOption.builder().title(state).value(state).build());
    return [SelectOption.builder().title("All").value(null).build(), ...list];
  }

  get yearOptions() {
    const list = YEARS.map(year => SelectOption.builder().title(`${year}`).value(year).build());
    return [SelectOption.builder().title("All").value(null).build(), ...list];
  }

  get periodOptions() {
    const list = Object.values(Period).map(period => SelectOption.builder().title(this.$stringUtils.formatPeriod(period)).value(period).build());
    return [SelectOption.builder().title("All").value(null).build(), ...list];
  }

  public mounted(): void {
    this.syncFilterFromQuery();
    this.loadPage();
  }

  private syncFilterFromQuery(): void {
    const q = this.$route.query;
    if (q.reportFilingDeadlineFrom) this.filter.reportFilingDeadlineFrom = q.reportFilingDeadlineFrom as string;
    if (q.reportFilingDeadlineTo) this.filter.reportFilingDeadlineTo = q.reportFilingDeadlineTo as string;
    if (q.taxReportForm) this.filter.taxReportForm = q.taxReportForm as any;
    if (q.state) this.filter.state = q.state as string;
    if (q.customerId) this.filter.customerId = Number(q.customerId);
    if (q.customerType) this.filter.customerType = q.customerType as any;
    if (q.pageNumber) this.filter.pageNumber = Number(q.pageNumber);
    if (q.sortBy) this.filter.sortBy = q.sortBy as any;
    if (q.sortDirection) this.filter.sortDirection = q.sortDirection as any;

    if (q.year) this.filter.year = Number(q.year);
    if (q.period) this.filter.period = q.period as any;
  }

  private applyRouteParams(): void {
    const query: any = {};
    if (this.filter.reportFilingDeadlineFrom) query.reportFilingDeadlineFrom = this.filter.reportFilingDeadlineFrom;
    if (this.filter.reportFilingDeadlineTo) query.reportFilingDeadlineTo = this.filter.reportFilingDeadlineTo;
    if (this.filter.taxReportForm) query.taxReportForm = String(this.filter.taxReportForm);
    if (this.filter.state) query.state = this.filter.state;
    if (this.filter.customerId) query.customerId = String(this.filter.customerId);
    if (this.filter.customerType) query.customerType = this.filter.customerType;
    if (this.filter.pageNumber > 1) query.pageNumber = String(this.filter.pageNumber);
    if (this.filter.sortBy !== TaxObligationSortField.CREATED_AT) query.sortBy = this.filter.sortBy;
    if (this.filter.sortDirection !== "DESC") query.sortDirection = this.filter.sortDirection;

    if (this.filter.year) query.year = String(this.filter.year);
    if (this.filter.period) query.period = this.filter.period;

    this.$router.replace({query}).catch(() => this.$void());
  }

  async handleSearch() {
    this.filter.pageNumber = 1;
    await this.loadPage();
  }

  async loadPage() {
    this.$loadOn();
    try {
      const response = await TaxObligationService.getTaxObligations(this.filter)
      this.taxObligations = response.data.content;
      this.totalPages = response.data.totalPages;
      this.applyRouteParams();
    } catch (e) {
      processError(e, this)
    } finally {
      this.$loadOff();
    }
  }

  public changePage(page: number): void {
    this.filter.pageNumber = page;
    this.loadPage();
  }

  public clearFilter(): void {
    this.filter = new TaxObligationFilter();
  }

  public onCustomerSelected(profile: ProfileDTO | null): void {
    if (profile) {
      this.filter.customerId = profile.id;
      this.filter.customerType = profile.type as any;
    } else {
      this.filter.customerId = null;
      this.filter.customerType = null;
    }
  }

  public switchOrder(field: TaxObligationSortField): void {
    if (this.filter.sortBy === field) {
      this.filter.sortDirection = this.filter.sortDirection === 'ASC' ? 'DESC' : 'ASC';
    } else {
      this.filter.sortBy = field;
      this.filter.sortDirection = 'ASC';
    }
    this.loadPage();
  }

  public getSortIcon(field: TaxObligationSortField): string {
    if (this.filter.sortBy !== field) {
      return "sort";
    }
    return this.filter.sortDirection === 'ASC' ? "sort-up" : "sort-down";
  }

  public getTaxReportFormLabel(type: TaxReportForm): string {
    return getTaxReportFormLabel(type);
  }

  public formatAmount(cents: number): string {
    return '$' + (cents / 100).toFixed(2);
  }

  goToEvent(id: number) {
    this.$router.push({ name: 'tax_obligation', params: { id: id.toString() } });
  }

  public formatDate(iso: string): string {
    if (!iso) return '';
    try {
      return moment(iso).format('MM/DD/YYYY HH:mm');
    } catch {
      return iso;
    }
  }

  public getFullPeriod(e: TaxObligationDTO): string {
    if(!e.year){
      return '-';
    } else if ((!e.period || e.period == Period.FULL_YEAR) && !!e.year){
      return e.year.toString();
    } else {
      return this.$stringUtils.formatPeriod(e.period) + ' ' + e.year;
    }
  }
}
